import * as React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link, useNavigate } from 'react-router-dom'; // Import Link and useNavigate from React Router

interface Props {
  window?: () => Window;
}

const drawerWidth = 240;
const navItems = ['Home', 'Achievements', 'Skills', 'Experience', 'Education', 'Projects', 'Certificates', 'Contact'];

const theme = createTheme({
  typography: {
    fontFamily: `'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif`,
  },
});

export default function DrawerAppBar(props: Props) {
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: 'center' }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        Lakshay Rohilla
      </Typography>
      <Divider />
      <List>
        {navItems.map((item) => (
          <ListItem key={item} disablePadding>
            <ListItemButton component={Link} to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} sx={{ textAlign: 'center', '&:hover': { color: 'var(--orange)' } }}>
              <ListItemText primary={item} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Box sx={{ mt: 2 }}>
        <Button
          onClick={() => navigate('/Contact')}
          className="button"
          sx={{
            color: 'white',
            borderRadius: '20px',
            p: 1,
            pr: 3,
            pl: 3,
          }}
        >
          Contact
        </Button>
      </Box>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: 'flex', pb: 6, pr: 3.5, pl: 3.5 }}>
        <CssBaseline />
        <AppBar component="nav" sx={{ backgroundColor: 'white', color: 'black', boxShadow: 'none' }}>
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ mr: 2, display: { sm: 'none' } }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'block', sm: 'none' }, textAlign: 'center', fontSize: '22px', fontWeight: 'bold' }}
            >
              Lakshay Rohilla
            </Typography>
            <Typography
              variant="h6"
              component="div"
              sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' }, ml: 4, fontWeight: 'bold', fontSize: '25px' }}
            >
              Lakshay
            </Typography>
            <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
              {navItems.map((item) => (
                <Button
                  key={item}
                  component={Link}
                  to={item === 'Home' ? '/' : `/${item.toLowerCase()}`} // Corrected logic for Home
                  sx={{ color: 'black', textTransform: 'none', fontSize: '17px', '&:hover': { color: 'var(--orange)' } }}
                >
                  {item}
                </Button>
              ))}
              <Button
                sx={{
                  ml: 6,
                  mr: 4,
                  color: 'white',
                  borderRadius: '20px',
                  p: 1,
                  pr: 3,
                  pl: 3,
                  textTransform: 'none',
                  fontWeight: 'bold',
                }}
                onClick={() => navigate('/Contact')}
                className="button"
              >
                Contact
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
        <nav>
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        </nav>
      </Box>
    </ThemeProvider>
  );
}